module.exports = __webpack_public_path__ + "static/media/editHover.73c81181.svg";